export const fetchQuery = 'operationSummariesByTimeRange';
export const fetchOperationDetailsQuery = 'operationSummary';
export const inAirQuery = 'operationsByTimeRange';

export const summarySchema = `
{
  totalCount
  pageInfo {
    startCursor
    endCursor
    hasNextPage
  }
  items{
    id
    acid
    operationType
    aircraftCategory
    aircraftType
    airportId
    endTime
    remoteAirportId
    runwayName
    startTime
    time
    correlated {
      infringements {
        infringementType
        id
      }
      noiseEvents {
        id
      }
      noiseEventCount
    }
  }
}
`;

export const operationDetailsSchema = `
  {
    id
    acid
    airline
    aircraftCategory
    aircraftType
    airportId
    operationType
    remoteAirportId
    runwayName
    time
    startTime
    endTime
    points {
      alt
      lat
      lon
      t
    }
    profile {
      y: altitude
      d: distance
      x: timeOffset
    }
    correlated {
      weather {
        precipitation
        cloudCover
        temperature
        relativeHumidity
        atmosphericPressure
        windSpeed
        windDirection
        visibility
        ceiling
      }
    }
  }
`;

export const inAirSchema = `
{
  id
  startTime
  endTime
  operationType
  aircraftCategory
  points {
    alt
    lat
    lon
    t
  }
}`;
